import React, { useContext, useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import FooterMenu from './FooterMenu';
import FooterSupport from './FooterSupport';
import GlobalContext from '../../contexts/GlobalContext';
import FooterSocialIcons from './FooterSocialIcons';
import FooterPoweredBySite from './FooterPoweredBySite';
import DoNotSellContainer from '../DoNotSell/DoNotSellContainer';

const FooterContainer = (): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const [openDoNotSellPopUp , setOpenDoNotSellPopup] = useState(false);

  const serviceSection = '1';
  const companySection = '2';
  const footerIntroText = globalContext.liquid.settings.footer_intro_text;
  const footerIntroHeading = globalContext.liquid.settings.footer_intro_heading;
  const isPoweredBySiteEnabled = globalContext.liquid.settings.enable_powered_by_site;

  const doNotSellOpenPopUp = () => {
    setOpenDoNotSellPopup(true)
    globalContext.gtm.setVirtualPage('Do_Not_Sell_View_Modal')
  };
  
  const componentRef = useRef({ doNotSellOpenPopUp });


  useEffect(() => {
    const handleEvent = () => {
        componentRef.current.doNotSellOpenPopUp();
    };

    window.addEventListener('triggerDoNotSellReactPopUp', handleEvent);

    return () => {
        window.removeEventListener('triggerDoNotSellReactPopUp', handleEvent);
    };
}, []);

  return (
    <footer className="footer-main" id="footer-new">
      <div className="footer-top">
        <div className="sj-footer-row footer-top__inner">
          <FooterMenu section={serviceSection} />
          <FooterMenu section={companySection} />
          <FooterSupport />
          <div className="footer-block footer-intro-block">
          <h4 className="footer-block__heading">{parse(footerIntroHeading)}</h4>
            <p className="footer-block__intro">{parse(footerIntroText)}</p>
          </div>
        </div>
      </div>
      {isPoweredBySiteEnabled && <FooterPoweredBySite />}
        <FooterSocialIcons />
        <div
          id="reqPop"
          data-reveal
          className="reveal regulatory-updates-modal"
          style={{ display: 'none' }}></div>
      {openDoNotSellPopUp && <DoNotSellContainer setClosePopup={setOpenDoNotSellPopup}/>}
    </footer>
  );
};

export default FooterContainer;
